import { ClipLoader } from "react-spinners";

type LoadingSpinnerProps = {
  size?: number;
};

export const LoadingSpinner = ({ size }: LoadingSpinnerProps) => {
  return (
    <div className="flex h-full flex-col justify-center">
      <ClipLoader
        cssOverride={{ display: "block" }}
        className={"m-auto !border-l-white !border-r-white !border-t-white"}
        size={size ?? 30}
      />
    </div>
  );
};
